// @ts-nocheck
import React, { useContext } from 'react';
import leveljs from 'level-js';
import levelup from 'levelup';
import {
  Form,
  User,
  Role,
  MemoryDataSource,
  LevelDBDataSource,
  DataSource,
} from '@fulcrumapp/fulcrum-core';

import ApiDataSource from '../shared/api-data-source';
import LocalStoragePreferences from '../utils/local-storage-preferences';
import LayerSettings from '../models/layer-settings';
import { Globals } from '../models/globals';
import { Role as RestRole } from '../models/role';
import Client from '../api/client';

export interface App {
  user: User;

  role: Role;

  restRole: RestRole;

  dataSource: DataSource;

  preferences: LocalStoragePreferences;

  objectCache: LevelDBDataSource;

  layerSettings: LayerSettings;

  globals: Globals;

  api: Client;

  params: any;

  form: Form;
}

export const AppContext = React.createContext<App>(null);

export const createObjectCache = () => {
  const leveldb = levelup('object-cache', { db: leveljs });
  return new LevelDBDataSource(leveldb);
};

export const initializeApp = (
  globals: Globals,
  objectCache: LevelDBDataSource | null,
  params: any,
): App => {
  const preferences = new LocalStoragePreferences();

  const dataSource = new DataSource();
  const memoryDataSource = new MemoryDataSource();
  const apiDataSource = new ApiDataSource(globals.token, '/api/v2', globals.config);

  dataSource.add(memoryDataSource);

  if (objectCache) {
    dataSource.add(objectCache);
  }

  dataSource.add(apiDataSource);

  const user = new User(globals.user);
  const role = new Role(globals.role);
  const restRole = globals.role;

  const layerSettings = new LayerSettings(
    globals.layers ?? [],
    params.form_id,
    globals.config.tile_url,
    globals.config.layer_url ?? globals.config.tile_url,
    preferences,
  );

  return {
    user,
    role,
    restRole,
    dataSource,
    preferences,
    objectCache,
    globals,
    params,
    layerSettings,
    api: apiDataSource.client,
  };
};

export const useApp = (): App => useContext<App>(AppContext);
